import { Suspense, useEffect } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { TopNav } from "./TopNav";
import { BottomNav } from "./BottomNav";
import { ErrorBoundary } from "@/components/ui/ErrorBoundary";
import { Spinner } from "@/components/ui/Meter";
import { useAuth } from "@/state/AuthContext";
import { CORE_FEATURES } from "@/lib/coreFeatures";

/** /app/* 区域的通用壳:顶导航(桌面)+ 底部导航(移动)+ 登录守卫。 */
export function AppShell() {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useAuth();
  const task = CORE_FEATURES.find(feature => location.pathname === feature.to || location.pathname.startsWith(feature.to + "/"))
    || (location.pathname.startsWith("/app/tools/scan/") ? CORE_FEATURES.find(feature => feature.key === "checkup") : undefined);

  // 登录守卫:仅在明确 401(unauthenticated)时跳登录页并带回跳地址;
  // 网络抖动 / 后端异常不踢人,避免误伤。SharePage / LandingPage 不走此壳,天然公开。
  useEffect(() => {
    if (!auth.loading && auth.unauthenticated) {
      const next = encodeURIComponent(location.pathname + location.search);
      navigate(`/auth?next=${next}`, { replace: true });
    }
  }, [auth.loading, auth.unauthenticated, location.pathname, location.search, navigate]);

  // 首次 me 未返回前不渲染业务页,防止"闪一下内容再跳登录"
  if (auth.loading) {
    return (
      <div className="app-shell">
        <TopNav />
        <main className="page-main">
          <div className="cluster">
            <Spinner /> 正在确认登录状态…
          </div>
        </main>
      </div>
    );
  }
  if (auth.unauthenticated) return null; // 跳转在途,渲染空避免闪烁

  return (
    <div className="app-shell">
      <TopNav />
      <main className="page-main">
        {task && <nav className="workspace-breadcrumb" aria-label="当前位置"><Link to="/app">工作台</Link><span aria-hidden="true">/</span><span aria-current="page">{task.name}</span></nav>}
        {/* 按路径 key,换页时自动重置错误态;单个页面崩溃只影响内容区,导航仍可用。 */}
        <ErrorBoundary key={location.pathname}>
          <Suspense fallback={<div className="cluster" role="status"><Spinner />正在载入页面…</div>}><Outlet /></Suspense>
        </ErrorBoundary>
      </main>
      <BottomNav />
    </div>
  );
}
